<template>
	<li>
		<a href="#" class="uk-accordion-title">{{ displayNumber }}. Murphy Bed Mattresses</a>
		<div class="uk-accordion-content">
			<!-- Mattress -->
			<div class="mattress-container">
				<div v-for="mattress in mattresses" class="mattress" :key="'mattress_' + mattress.id" @click.prevent="toggleMattress(mattress)" :class="{'selected':mattressIsSelected(mattress)}">
					<div class="uk-child-width-1-2@m uk-grid-small uk-flex-middle" uk-grid>
						<div class="uk-text-center">
							<p class="mattress-name">{{ mattress.name }}</p>
							<img v-if="mattress.logo_image" :src="mattress.logo_image.webPath + '/140'" alt="Mattress Brand">
							<p>{{ mattress.quality }}</p>
							<img width="200" :src=" mattress.image ? mattress.image.webPath + '/200':'/wp-content/themes/wallbeds/img/mattress-placeholder.jpg'" alt="Mattress Image">
							<p v-if="useDiscounts && mattress.price.discount_amount > 0" class="extra-price old-price">{{ mattress.price.price | diffcurrency }}</p>
							<p class="extra-price">{{ calculatePrice(mattress.price) | diffcurrency }}</p>
						</div>
						<div>
							<p class="description" v-html="mattress.description"></p>
							<p class="height">Height: {{ renderHeight(mattress.height, 11) }}</p>
							<div class="ratings-table">
								<div class="rating">
									<div class="grid">
										<div>
											<p>Comfort</p>
										</div>
										<div>
											<div class="bar-container">
												<span class="left">FIRM</span>
												<span class="middle">MEDIUM</span>
												<span class="right">SOFT</span>
											</div>
											<div class="progress-bar">
												<span class="progress-bar-fill" :style="renderProgress(mattress.comfort_rating, 40)"></span>
											</div>
										</div>
									</div>
								</div>
								<div class="rating">
									<div class="grid">
										<div>
											<p>Support</p>
										</div>
										<div>
											<div class="bar-container">
												<span class="left">LOW</span>
												<span class="middle">MEDIUM</span>
												<span class="right">HIGH</span>
											</div>
											<div class="progress-bar">
												<span class="progress-bar-fill" :style="renderProgress(mattress.support_rating, 90)"></span>
											</div>
										</div>
									</div>
								</div>
								<div class="rating">
									<div class="grid">
										<div>
											<p>Quality</p>
										</div>
										<div>
											<div class="bar-container">
												<span class="left">CHILD</span>
												<span class="middle">GUEST</span>
												<span class="right">MASTER</span>
											</div>
											<div class="progress-bar">
												<span class="progress-bar-fill" :style="renderProgress(mattress.quality_rating, 70)"></span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="bb-video-popup">
				<h3>
					<a href="#" class="info">
						<svg class="svg-inline--fa fa-info fa-w-6" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="info" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" data-fa-i2svg="">
							<path fill="currentColor" d="M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"></path>
						</svg>
					</a>
					Do Murphy Beds require a special mattress?
				</h3>
				<div class="uk-flex uk-flex-middle">
					<div>
						<p>Watch this video to learn more about selecting a mattress for your Murphy Bed</p>
					</div>
					<div>
						<div uk-lightbox="video-autoplay: true;"><a href="https://www.youtube.com/watch?v=I-VKz17wxPs" class="placeholder"><img src="/wp-content/themes/wallbeds/img/placeholder.8fcab5a0.jpg" alt="Video Placeholder"></a></div>
					</div>
				</div>
			</div>
		</div>
	</li>
</template>

<script>

import {mapState} from "vuex";

export default {
	name: "Mattress",
	
	props: {
    displayNumber:{
      type: Number,
      default: 4
    }
  },
	components: {},
	data() {
		return {}
	},
	mounted() {
		
	},
	methods: {
		mattressIsSelected(mattress){
			return this.selected_mattress && this.selected_mattress.id == mattress.id;
		},
		toggleMattress(mattress){
			if(this.selected_mattress && this.selected_mattress.id == mattress.id){
				this.$store.commit('setSelectedMattress', null);
			} else {
				this.$store.commit('setSelectedMattress', mattress);
			}
		},
		renderProgress(value, def){
			if(value === null || value === undefined){
				return "width: " + def + "%;";
			}
			
			return "width: " + value + "%;";
		},
		renderHeight(value, def){
			if(value === null || value === undefined){
				return def + '"';
			}
			
			return value + '"';
		},
		calculatePrice(price){
			if(this.useDiscounts && price.discount_amount){
				return price.price - price.discount_amount;
			}
			return price.price;
		}
	},
	computed: {
		...mapState({
			wallbed : state => state.wallbed,
			mattresses :  state => state.mattresses,
			selected_mattress : state => state.selected_mattress,
			useDiscounts: state => state.useDiscounts
		})
	},
	watch: {}
}
</script>